import React from "react";
import { Box, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import WhiteButton from "src/components/button/WhiteButton";
import { useRouter } from "next/router";
import { GREY } from "src/theme/palette";

export default function NewSuccessDialog(props) {
  const { open, onClose, successText, credit, message, disableBtn, disableCredit } = props;
  const Router = useRouter();
  const closeDialog = () => {
    onClose();
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          backgroundColor: "white",
          margin: 0,
          width: "600px",
          padding: "24px",
        },
      }}
      onClose={closeDialog}
      maxWidth="xl"
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogContent dividers>
      <Box sx={{position:'absolute',right:15,top:15,background:GREY[75],p:"4px",borderRadius:'14px',cursor:'pointer'}} onClick={closeDialog}>
          <img
            src="/images/cancel.svg"
            alt=""
            width="18px"
            height="18px"
          />
        </Box>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/icons/uploadFile/success.svg"
            alt=""
            width="32px"
            height="32px"
          />
        </div>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", pt: "16px" }}
          color="textPrimary"
          align="center"
        >
          {successText}
        </Typography>
        <div
          style={{ textAlign: "center", paddingTop: "10px"}}
        >
          Your order has been successfully submitted
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Box
            display="flex"
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent="center"
            width="360px"
            height="250px"
            border="1px solid #EEEEEE"
            borderRadius={"8px"}
            my={2}
            align="center"
            py="24px"
            gap='10px'
            px='10px'
          >
            <img
              src="/icons/uploadFile/clock.svg"
              alt=""
              width="40px"
              height="40px"
            />
            <Typography>{message ? message : `You can track your order in my work`}</Typography>
            {!disableBtn && 
            <WhiteButton
              fullWidth
              onClick={() =>{
                Router.push("/dashboard/my_projects?tab=ACTION_REQUIRED");
                onClose();}
              }
              sx={{
                border: "0.5px solid grey",
                height: "38px",
                backgroundColor: "#F9F9F9",
                width: "332px",
                "&:hover": {
                  color: "#fff",
                  border: "1px solid #262626",
                  backgroundColor: "#262626",
                },
              }}
            >
              Track Your Order
            </WhiteButton>}
          </Box>
        </div>
        {!disableCredit && 
        <Typography variant="h6" align="center" sx={{ fontWeight: 500 }}>
          Avaliable Credits: <strong>{credit}</strong>
        </Typography>}
        <Box display="flex" justifyContent="center" mt={3} mb={4}></Box>
      </DialogContent>
    </Dialog>
  );
}

NewSuccessDialog.defaultProps = {
  successText: "",
};
